/* eslint-disable import/prefer-default-export */
import React, { useEffect, useState } from 'react'
import styles from '../../settings.page.styl'
import type { StepProps } from '@src/components/setup.steps/models'
import { SubmitButton } from '@src/components/common/button'
import { Prompt } from 'react-router-dom'
import type { Action, Location } from 'history'
import confirm from '@src/utils/confirm'

export const SubmitFooter: React.FC<StepProps> = ({
  disabledNext,
  history
}: StepProps) => {
  const [confirmedNavigation, setConfirmedNavigation] = useState(false)
  const [lastLocation, setLastLocation] = useState<Location | null>()

  function handleBlockedNavigation(
    nextLocation: Location,
    action: Action
  ): boolean {
    if (!confirmedNavigation && !disabledNext) {
      setLastLocation(nextLocation)
      confirm({
        message:
          'You have unsaved changes. Are you sure you want to leave this page?',
        onSuccess: () => {
          setConfirmedNavigation(true)
        }
      })
      return false
    }
    return true
  }

  useEffect(() => {
    if (confirmedNavigation && lastLocation) {
      // Navigate to the previous blocked location with your navigate function
      history.push(lastLocation.pathname)
    }
  }, [confirmedNavigation, lastLocation])

  return (
    <>
      <Prompt when={!disabledNext} message={handleBlockedNavigation} />
      <div className={styles.buttonWrapper}>
        <SubmitButton
          disabled={disabledNext}
          className={styles.saveButton}
          title={'SAVE'}
        />
      </div>
    </>
  )
}
